// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2zG3R","choiceBoxes":"toolbarselects_choiceBoxes__179Al","simpleField":"toolbarselects_simpleField__3LhIi"};